
export class CCValidationError extends Error {
  constructor(error) {
    super(error.message);
    this.code = error.code;
  }
}